import React from 'react';
import { connect } from 'react-redux';
import useSheet from 'app/jss';
import colorUtils from 'color';
import ConfirmBox from 'app/components/commons/ConfirmBox';
import { acceptFriendRequest, rejectFriendRequest } from 'app/actions/friendRequestActions';

type Props = {
  requestId: number,
  onAccept: () => void,
  onReject: () => void,
  sheet: object,
};

class FriendTheyRequestPanel extends React.Component {
  props: Props;

  render() {
    const { sheet: { classes }, onAccept, onReject, requestId } = this.props;
    return (
      <div className={classes.request}>
        <ConfirmBox
          onConfirm={() => onAccept(requestId)}
          onCancel={() => onReject(requestId)}
          gap={35}
        />
      </div>
    );
  }
}

function applyStyles(theme: Theme) {
  return {
    request: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexGrow: 1,
      color: theme.color.basis3,
      backgroundColor: theme.color.white,
      borderBottom: {
        color: colorUtils(theme.color.basis4)
          .alpha(0.2)
          .toString(),
        width: 1,
        style: 'solid',
      },
    },
  };
}

const actions = {
  onAccept: acceptFriendRequest,
  onReject: rejectFriendRequest,
};

export default useSheet(applyStyles)(connect(() => ({}), actions)(FriendTheyRequestPanel));
